import React from "react";
import { AuthPage } from "../../auth/auth-page";

// opened from the link in the password reset mail
export const ResetPasswordConfirm = () => <AuthPage view="reset" />;
